import React from 'react';

export interface ServiceWorkerContextType {
  supported: boolean;
  registration: ServiceWorkerRegistration;
}

const ServiceWorkerContext = React.createContext<ServiceWorkerContextType>({
  supported: false,
  registration: null,
});

export default ServiceWorkerContext;
